import { usePermissions } from "@/features/auth/hooks/usePermissions";

/**
 * Persona Opportunities IAM is tenant-scoped (KTD13): Super Tenant membership
 * alone does not unlock list/create/tuning. Use `perms.*.isOn` — not
 * `useIamPermission`, which ORs in the platform Super Tenant bypass.
 */
export function usePersonaOpportunityPermissions() {
  const perms = usePermissions();

  return {
    canListSets: perms.PERSONA_OPPORTUNITY_SETS_LIST.isOn,
    canCreateSet: perms.PERSONA_OPPORTUNITY_SETS_GENERATE.isOn,
    /** Same ACTION as create — gates persona script generate (U6 / U11). */
    canGenerateScripts: perms.PERSONA_OPPORTUNITY_SETS_GENERATE.isOn,
    canUseQueryTuning: perms.PERSONA_OPPORTUNITY_SETS_QUERY_TUNING.isOn,
    /** Leftover Create Set — required to offer Competitor driven generate. */
    canGenerateCompetitorSet: perms.OPPORTUNITY_SETS_CREATE.isOn,
  };
}
